var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',_vm._g(_vm._b({ref:_vm.name,scopedSlots:_vm._u([{key:"default",fn:function(v){return [_c('v-form',{on:{"submit":function($event){$event.preventDefault();v.handleSubmit(() => _vm.submit(v))}}},[_vm._t("default",null,null,v)],2)]}}],null,true)},'ValidationObserver',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }